import React, { useEffect } from "react";
import { ArcButton, ArcStack, ArcText } from "@src/core/ui";
import { FormState, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { setZoneMapLocationUponCreation, useUpdateZoneMutation } from "@src/features/zones/redux";
import { routesConfig } from "@src/core/routes";
import { ZoneForm } from "@src/features/zones/components/zone-form";
import { ICreateZoneStage1Form } from '@src/features/zones/pages/create-zone/stage1/types';
import { EditZoneStage1Props } from "./types";
import { useDispatch } from "react-redux";
import { ZoneShapeType } from "@src/core/features";
import { setMapLocation } from "@src/core/controllers";


export const EditZoneStage1Page: React.FC<EditZoneStage1Props> = (props) => {
  const { zone } = props;
  const { control, setValue, getValues, register, formState: { errors }, handleSubmit, watch } = useForm<ICreateZoneStage1Form>({ 
    defaultValues: { 
      id: zone.id,
      zoneName: zone.name,
      zoneDescription: zone.description,
      zoneRadius: zone.radiusMeters,
      latitude: zone.centerLatitude.toString(),
      longitude: zone.centerLongitude.toString(),
      zoneType: zone.zoneType,
      address: zone.locationName ?? ''
    } as ICreateZoneStage1Form
  });

  const dispatch = useDispatch();
  const [updateZone, { isLoading }] = useUpdateZoneMutation();
  const navigate = useNavigate();

  useEffect(()=> {
    dispatch(setZoneMapLocationUponCreation({
      id: zone.id,
      latitude: zone.centerLatitude,
      longitude: zone.centerLongitude,
      radius: zone.radiusMeters,
      type: zone.zoneType,
      zoneName: zone.name,
    }));
    dispatch(setMapLocation({
      latitude: zone.centerLatitude,
      longitude: zone.centerLongitude,
      address: zone.locationName ?? '',
    }));
    return () => {
      dispatch(setZoneMapLocationUponCreation(null));
    };
  }, [zone]);

  const onSubmit = async (data: ICreateZoneStage1Form) => {
    try {

      const radiusMeters = data.zoneRadius;

      await updateZone({ id: zone.id, 
        name: data.zoneName,
        description: data.zoneDescription, 
        centerLatitude: Number(data.latitude), 
        centerLongitude: Number(data.longitude), 
        locationName: data.address, 
        radiusMeters, 
        shape: ZoneShapeType.CIRCLE, 
        zoneType: data.zoneType, 
        isActive: true, 
        polygonCoordinates: [] }).unwrap();
      dispatch(setZoneMapLocationUponCreation(null));
      navigate(routesConfig.zones); 
    } catch (error) {
      console.error('Failed to create zone:', error);
    }
  };

  const onCancel =()=> { 
    navigate(-1);
    dispatch(setZoneMapLocationUponCreation(null));
  };
    
  return (
    <ArcStack height="100%" direction="column" justifyContent="space-between">
      <ArcStack flex={1}>
        <ArcText.h4 fontWeight={500} marginTop={2}> EDIT ZONE </ArcText.h4>

        <ZoneForm
          control={control}
          setValue={setValue}
          register={register}
          getValues={getValues}
          formState={{ errors } as FormState<ICreateZoneStage1Form>}
          watch={watch}
        />
      </ArcStack>

      <ArcStack spacing={2} direction='row' px={1}>
        <ArcButton.ghost
          fullWidth 
          size='large'
          onClick={onCancel}> 
          Cancel 
        </ArcButton.ghost>

        <ArcButton.brand 
          fullWidth
          size='large'
          type='submit'
          isLoading={isLoading}
          onClick={handleSubmit(onSubmit)}> 
          Update
        </ArcButton.brand>
      </ArcStack>
    </ArcStack>
  );
};